import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import useReport from "../../services/useReport";

const formatCurrency = (value: number) => {
  return value.toString().replace(".", ",");
};

const Report = () => {
  const { data, isLoading } = useReport();

  if (isLoading) {
    return <Box>Loading...</Box>;
  }

  if (!data) {
    return null;
  }

  return (
    <Box>
      <Table
        component={Paper}
        sx={{
          margin: "2rem auto",
          maxWidth: "50rem",
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>Parceira</TableCell>
            <TableCell>Total</TableCell>
            <TableCell>Frete</TableCell>
            <TableCell>Extrato</TableCell>
            <TableCell>Semente</TableCell>
            <TableCell>Agricultor</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.orders.map((order, index) => (
            <TableRow key={index}>
              <TableCell>{order.urban_partner}</TableCell>
              <TableCell>{formatCurrency(order.total)}</TableCell>
              <TableCell>{formatCurrency(order.delivery_fee)}</TableCell>
              <TableCell></TableCell>
              <TableCell>{formatCurrency(order.seed_total)}</TableCell>
              <TableCell>{formatCurrency(order.farmer_total)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Table
        component={Paper}
        sx={{
          margin: "2rem auto",
          maxWidth: "50rem",
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>Agricultora</TableCell>
            <TableCell>Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.farmer_orders.map((order, index) => (
            <TableRow key={index}>
              <TableCell>{order.farmer}</TableCell>
              <TableCell>{formatCurrency(order.total)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default Report;
